import i18n from 'i18next';
import HttpBackend, { type HttpBackendOptions } from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export const I18N_NAMESPACES = [
  'common',
  'visits',
  'patients',
  'referrals',
  'qa',
] as const;

export const i18nReady = i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init<HttpBackendOptions>({
    lng: 'en',
    fallbackLng: 'en',
    supportedLngs: ['en'],
    ns: [...I18N_NAMESPACES],
    defaultNS: 'visits',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  });

export default i18n;
